import * as angular from "angular";
import {IController} from "angular";

export class ContractLinkCtrl implements IController {
  name: string;
  programId: string;

  $onInit() {

  }

  $onChanges(changes: angular.IOnChangesObject) {

  }

}

angular
  .module('bringoz.admin.contracts')
  .component('contractLink', {
    bindings: {
      id: '<',
      name: '<',
      programId: '<'
    },
    template: require('./contract-link.html').default,
    controller: ContractLinkCtrl
  });
